import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddLeadSource = ({ show, onClose, refresh }) => {
    const [leadsource_name, setname] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [existingLeadsource, setExistingLeadsource] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
            if (show) {
                axios.get(`${baseURL}/leadsource`) 
                    .then(response => {
                        setExistingLeadsource(response.data.data.data.map(leadsource => leadsource.leadsource_name.toLowerCase()));
                    })
                    .catch(error => {
                        console.error("Error fetching leadsource", error);
                    });
            }
            }, [show]);

            const formatleadsourceName = (name) => {
                return name.charAt(0).toUpperCase() + name.slice(1);
            };

            const validateInput = () => {
                // Check if the Lead type name is empty
                if (!leadsource_name.trim()) {
                    setError("Leadsource is required.");
                    return false;
                }
                
                const regex = /^[A-Za-z\s]+$/;
                if (!regex.test(leadsource_name)) {
                    setError("Only text is valid.");
                    return false;
                }
        
                // Check if the leadtype already exists
                if (existingLeadsource.includes(leadsource_name.trim().toLowerCase())) {
                    setError("Leadsource already exists.");
                    return false;
                }
        
                setError('');
                return true;
            };

            const handleSubmit = (event) => {
                event.preventDefault();
        
                const formattedleadsourceName = formatleadsourceName(leadsource_name);
                // Run validation before submitting
                if (!validateInput()) return;
        
                const postData = { 
                    leadsource_name: formattedleadsourceName,
                    description: description.trim() || "-"
                 };
                
        
                // Send the request to the backend
                axios.post(`${baseURL}/leadsource`, postData)
                    .then(response => {
                        refresh();
                        onClose();
                        toast.success("Lead Source created successfully!");
                        // window.location.reload(); // Optionally update the UI with new data
                    })
                    .catch(error => {
                        setError("An error occurred while creating the lead type.");
                        console.error("Error:", error);
                    });
            };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Lead Source</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Lead Source<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Lead Source" 
                            value={leadsource_name} 
                            onChange={(e) => setname(formatleadsourceName(e.target.value))}/>
                            {error && <small className="text-danger">{error}</small>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Description" 
                            value={description}
                            onChange={(e) => setDescription(e.target.value)} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <button type="submit" className="btn btn-sm btn-primary">Create Lead Source<i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default AddLeadSource;
